<template>
  <div class="product-table-container">
    <div v-if="isProductsLoading" class="product-table-loading">
      <div class="product-table-loading-container">
        <img src="/img/ic_loading.svg">
      </div>
    </div>
    <div v-if="getProducts.length" class="row">
      <div class="col-sm-12">
        <div class="table-nav-top">
          <div class="table-nav-top__selected">
            <p v-if="getSelected.length" class="selected__text">Выбрано <span class="selected__num">{{ getSelected.length }}</span> из <span>{{ maxSelected }}</span></p>
            <button @click="showExportModal" class="btn btn-lg selected__btn">
              <img src="/img/ic_download.svg" alt="">
              <template v-if="getSelected.length">Экспортировать выбранные</template>
              <template v-else>Экспортировать все</template>
            </button>
          </div>
          <div class="table-nav-top__total">
            <p>
              <span>{{ currentItemsPagination }}</span> из <span>{{ Number(getPagination.totalCount).toLocaleString() }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-selected">
      <div class="col-sm-12">
        <div v-if="getPagination.limit && limitAlertShow" class="alert alertNotFound">
          <h3 class="alertNotFound__header">
            <img src="/img/ic_attention.svg" alt=""><span>Ошибка поиска</span>
            <button type="button" class="close" aria-hidden="true" @click="limitAlertShow=!limitAlertShow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8L8 16" stroke="#FBE9EB" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
                <path d="M16 16L8 8" stroke="#FBE9EB" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </button>
          </h3>
          <ul class="alertNotFound__list">
            <li>Количество референсов для поиска не должно превышать {{ getPagination.limit }} шт. Поиск был осуществлен по первым {{ getPagination.limit }} значениям.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="product-table-wrapper">
      <table class="table table-hover product-table" :class="!getProducts.length ? 'table-hidden' : ''">
        <tbody>
          <tr>
            <th>
              <checkbox
                class="catalog__checkbox-label--empty"
                :checked="isSelectedPage"
                :disabled="!getProducts.length"
                @click.native.prevent="selectProduct(getProducts)" />
            </th>
            <th>Референс</th>
            <th>Описание товара</th>
            <th>Тариф</th>
            <th>Линейка</th>
          </tr>
          <tr v-if="!isEmptyTableFilters || getProducts.length" class="table-inputs-string">
            <th></th>
            <th>
              <table-filter-input filter="reference" input-class="catalog__input-reference" />
            <th>
              <table-filter-input filter="description" input-class="catalog__input-product" />
            </th>
            <th>
              <content-placeholders v-if="rates.loading">
                <content-placeholders-text :lines="1" />
              </content-placeholders>
              <v-select
                v-else
                :searchable="false"
                :appendToBody="true"
                class="v-select-rate"
                @input="(item) => setTableFilter('rate', item)"
                placeholder="Не выбрано"
                :options="Object.keys(rates.items)"
                :getOptionLabel="option => rates.items[option]"
                :value="getTableFilter.rate"
                 />
            </th>
            <th>
              <v-select
                @search="findLines"
                :appendToBody="true"
                :filterable="false"
                class="v-select-lines"
                :class="{ 'v-select-focused' : lines.focused }"
                @input="(item) => setTableFilter('lines', item)"
                placeholder="Не выбрано"
                :options="Object.keys(linesItems)"
                :getOptionLabel="option => linesItems[option]"
                :value="getTableFilter.lines"
                :calculate-position="calculateLinesPosition"
                >
                <template #no-options="{ search }">
                  {{ search.length ? 'Ничего не найдено.' : 'Начните ввод.' }}
                </template>
              </v-select>
            </th>
          </tr>
          <tr v-for="(product, index) in getProducts" :key="index">
            <td>
              <checkbox
                class="catalog__checkbox-label--empty"
                :checked="getSelected.indexOf(product.id) !== -1"
                @click.native.stop.prevent="selectProduct(product)" />
            </td>
            <td><a class="catalog__trable-link" :href="product.url">{{ product.reference }}</a></td>
            <td><a v-html="product.description" class="catalog__trable-link" :href="product.url"></a></td>
            <td><a v-html="getProductRates(product)" class="catalog__trable-link" :href="product.url"></a></td>
            <td><a v-html="product.lines ? getProductLines(product) : ''" class="catalog__trable-link" :href="product.url"></a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="getProducts.length" class="row post-table-nav">
      <div class="col-sm-12">
        <div class="post-table-nav-inner">
          <div class="post-table-nav-inner__choosen">
            <p v-if="getSelected.length" class="selected__text">Выбрано <span class="selected__num">{{ getSelected.length }}</span></p>
          </div>
          <div v-if="getPagination.pageCount > 1" class="post-table-nav-inner__page-pagin">
            <paginate
              :page-count="getPagination.pageCount"
              :value="getPagination.current"
              prev-text="<img src='/img/ic_arrow.svg'>"
              next-text="<img src='/img/ic_arrow-next.svg'>"
              container-class="pagination"
              :click-handler="changePage">
            </paginate>
          </div>
          <div class="post-table-nav-inner__page-num">
            <p>
              <span>{{ currentItemsPagination }}</span> из <span>{{ Number(getPagination.totalCount).toLocaleString() }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="notFound-Result">
      <img src="/img/ic_search-big.svg" alt="">
      <p>Для поиска выберите категории слева или воспользуйтесь поисковой строкой</p>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import TableFilterInput from '@/components/TableFilterInput'
import Checkbox from '@/components/Checkbox'
import {mapGetters} from 'vuex'
import {
  CLEAR_PAGINATION_LIMIT,
  REMOVE_FILTER,
  SEARCH,
  SET_BUFFER_LINES,
  SET_CURRENT_PAGE,
  SET_FILTER,
  SET_FILTER_DATA,
  SET_TABLE_FILTER
} from '@/store/actions/search'
import {SET_SELECTED} from '@/store/actions/product'
import {MAX_SELECTED} from '@/store/modules/product'
import debounce from 'lodash/debounce'
import {createPopper} from '@popperjs/core'

export default {
  name: 'product-table',
  components: {
    Paginate,
    TableFilterInput,
    Checkbox
  },
  data: () => ({
    rates: {
      loading: true,
      items: {}
    },
    lines: {
      query: '',
      loading: false,
      items: {}
    },
    limitAlertShow: true
  }),
  created () {
    this.$api.catalog.rates().then((response) => {
      this.rates.items = response.data.reduce((allRates, rate) => ({
        ...allRates,
        [rate.code]: rate.tariff
      }), {})
      this.rates.loading = false
    })

    this.api.then((response) => {
      const { data } = response
      this.$store.dispatch(SET_FILTER_DATA, { data, type: 'table' }).then(() => {

      })
    })
  },
  computed: {
    api () {
      return this.$api.filter.table()
    },
    maxSelected () {
      return MAX_SELECTED
    },
    currentItemsPagination () {
      const p = this.getPagination
      return `${((p.current - 1) * p.perPage) + 1} - ${p.pageCount > 1 ? p.current * p.perPage : p.totalCount}`
    },
    linesItems () {
      const items = {
        ...!this.lines.query
          ? { ...this.getBufferLines, ...this.getProductPageLines }
          : {},
        ...this.lines.items
      }
      return items
    },
    ...mapGetters([
      'getProducts',
      'getType',
      'getPagination',
      'getSelected',
      'isSelectedPage',
      'getFoundDom',
      'getFoundCount',
      'getTableFilter',
      'getBufferLines',
      'isEmptyTableFilters',
      'getProductPageLines',
      'isProductsLoading'
    ])
  },
  methods: {
    calculateLinesPosition (dropdownList, component) {
      dropdownList.classList.add('dropdown-menu-lines')
      const popper = createPopper(component.$refs.toggle, dropdownList, { placement: 'bottom-end' })
      return () => popper.destroy()
    },
    setTableFilter (filter, value = '') {
      if (value === '') {
        this.value = this.getTableFilter.rate
      }
      let buffer = { ...this.getBufferLines }
      if (filter === 'lines') {
        if (value !== '' && this.linesItems[value]) {
          buffer[value] = this.linesItems[value]
        } else {
          buffer = {}
        }
      }
      this.$store.dispatch(SET_TABLE_FILTER, { filter, value }).then(() => {
        this.$store.dispatch(SET_BUFFER_LINES, buffer).then(() => {
          const { $router: router } = this
          this.$store.dispatch(SEARCH, { router })
        })
      })

      const type = 'table'
      this.$store.dispatch(REMOVE_FILTER, {type, filter}).then(() => {
      })

      this.$store.dispatch(SET_FILTER, {type, filter, value}).then(() => {
        this.value = value
      })
    },
    clearPaginationLimit () {
      this.$store.dispatch(CLEAR_PAGINATION_LIMIT)
    },
    getProductRates (product) {
      return Object.entries(product.rates).reduce((allRate, [, rate]) => ([
        ...allRate,
        rate
      ]), []).join('<br>')
    },
    getProductLines (product) {
      return Object.entries(product.lines).reduce((allLine, [, line]) => ([
        ...allLine,
        line
      ]), []).join('<br>')
    },
    selectProduct (product) {
      this.$store.dispatch(SET_SELECTED, product)
    },
    changePage (page) {
      const { $router: router } = this
      this.$store.dispatch(SET_CURRENT_PAGE, { router, page })
    },
    findLines (query, loading) {
      this.lines.query = query
      this.lines.items = []
      if (query.length) {
        loading(true)
        this.lines.loading = true
        this.findLinesDebounce(query, loading)
      }
    },
    showExportModal () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Клик по кнопке',
          action: this.getSelected.length ? 'Экспортировать выбранные' : 'Экспортировать все'
        })
      }
      this.$root.$emit('archive-modal::show', this.getSelected)
    },
    findLinesDebounce: debounce(function (query, loading) {
      query = query.trim()
      this.$api.catalog.lines({ name: query }).then(response => {
        this.lines.items = response.data.reduce((allLines, lines) => ({
          ...allLines,
          [lines.id]: lines.name
        }), {})
      }).finally(() => {
        this.lines.loading = false
        loading(false)
      })
    }, process.env.VUE_APP_DEBOUNCE_TIME),
  }
}
</script>